import { render, staticRenderFns } from "./KlarnaModal.vue?vue&type=template&id=1d0d84ba&scoped=true"
import script from "./KlarnaModal.vue?vue&type=script&lang=js"
export * from "./KlarnaModal.vue?vue&type=script&lang=js"
import style0 from "./KlarnaModal.vue?vue&type=style&index=0&id=1d0d84ba&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d0d84ba",
  null
  
)

export default component.exports